import { AppFeatures } from "@/components/landing/AppFeatures";
import { PageFooterNav } from "@/components/landing/PageChrome";
import { SEO } from "@/components/SEO";

export default function PageApp() {
  return (
    <>
      <SEO
        title="L'application Zafara"
        description="Une application marketplace 100% béninoise, pensée pour les commerces, vendeurs et livreurs indépendants du Bénin. Rapide même en 3G."
        path="/application"
      />
      <AppFeatures />
      <PageFooterNav
        prev={{ to: "/pourquoi-zafara", label: "Pourquoi Zafara" }}
        next={{ to: "/fondateur", label: "Le fondateur" }}
      />
    </>
  );
}
